<template>
    <div>
        <div class="hide-on-med-and-down" style="margin-bottom:62px;">
            <div class="container">
                <div class="row row-bottom-0">
                    <div class="col s12 m12 12 center">
                        <div id='products' @click="productClick" :class="{products_clicked: isClick}">
                            <div class="oval-mask left">
                                <div>
                                    <img :src="url" />
                                </div>
                            </div>
                            <div class="personalized-welcome-text default-contact left">{{title}}                                 
                            </div>
                            <div id="right_arrow" ><img src="/assets/img/right_arrow.svg" style="width:25px !important;height:25px !important;" /></div>
                            <div class="personalized-welcome-text mover-contact left"> {{description}}                                 
                                <div v-if="point1 !== ''"  class="bulletin-point">| {{point1}}</div>
                                <div v-if="point2 !== ''"  class="bulletin-point">| {{point2}}</div>
                                <div v-if="point3 !== ''" class="bulletin-point">| {{point3}}</div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hide-on-large-only">
            <div class="container">
                <div class="row row-bottom-0">
                    <div class="col s12 m12 12 center">
                        <div class="product-detail-card">
                            <div class="row">
                                <div class="col s12 m12 l12">
                                    <div class="oval-mask">
                                        <div>
                                            <img :src="url" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row row-bottom-0 ">
                                <div class="col s12 m12 l12">
                                    <div class="personalized-welcome-text default-contact"> {{title}} </div>
                                    <div class="personalized-welcome-text mover-contact left"> {{description}}                                 
                                        <div v-if="point1 !== ''"  class="bulletin-point">| {{point1}}</div>
                                        <div v-if="point2 !== ''"  class="bulletin-point">| {{point2}}</div>
                                        <div v-if="point3 !== ''" class="bulletin-point">| {{point3}}</div>                                
                                    </div>
                                </div>
                            </div>                            
                            <div class="row">
                                <div class="col s12 m12 l12">
                                    <i class="material-icons down-circle-arrow"><img src="/assets/img/down_arrow_circle.svg" style="width:25px !important;height:25px !important;" /></i>
                                    <i class="material-icons up-circle-arrow"><img src="/assets/img/up_arrow_circle.svg" style="width:25px !important;height:25px !important;" /></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "products",
  props: ["url", "title", "description", "point1", "point2", "point3"],
  data() {
        return { isClick: false }    
  },
  methods:{
      productClick() {
        this.isClick = !this.isClick
      }
  }
};
</script>

